
import {
  defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import { useGradeBase } from '@/core/composables/GradeBase';
import { useTelaBase } from '@/core/composables/TelaBase';
import { IPagination } from '@/core/models/AntDesign/IPagination';
import { IListaPaginadaMetaData } from '@/core/models/Consulta/IListaPaginada';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import Icone from '@/core/components/Icone.vue';
import Card from '@/core/components/Tela/Card.vue';
import ServicoRelatorioEstoque from '@/servicos/Relatorios/ServicoRelatorioEstoque';
import SelecionarCategoria from '@/components/Cadastros/Produtos/SelecionarCategoria.vue';
import SelecionarMarca from '@/components/Cadastros/Produtos/SelecionarMarca.vue';
import SelecionarFornecedor from '@/components/Cadastros/Pessoas/Fornecedores/SelecionarFornecedor.vue';
import SelecionarTipoCusto from '@/components/Cadastros/Precificacao/SelecionarTipoCusto.vue';
import { IFiltroRelatorioInventarioPorLote, IDTORelatorioInventarioPorLote } from '@/models/DTO/Relatorios/Inventario/IDTORelatorioInventarioPorLote';
import { IDadosRelatorioInventarioPorLote } from '@/models/Relatorios/Estoque/IDadosRelatorioInventarioPorLote';

export default defineComponent({
  name: 'RelatorioInventarioPorLote',
  components: {
    TituloPadrao,
    Icone,
    Card,
    SelecionarCategoria,
    SelecionarMarca,
    SelecionarFornecedor,
    SelecionarTipoCusto,
    PreviewPdf,
    SelecionarData,
  },
  setup(props) {
    const servicoSistema = new ServicoSistema();
    const servicoRelatorioEstoque = new ServicoRelatorioEstoque();
    const {
      telaBase, filtrarPermissaoDadosUsuarioMultiEmpresas, apresentarMensagemAlerta, apresentarMensagemErro,
      preencherEmpresasDisponiveis, verificaConceitoParaApresentarEmpresas, defineEmpresasSelecionadasComPermissao,
      preencherDadosRota,
    } = useTelaBase();
    const { gradeBase } = useGradeBase();
    const state = reactive({
      filtros: {} as IFiltroRelatorioInventarioPorLote,
      filtrosUtilizados: {} as IFiltroRelatorioInventarioPorLote,
      resultado: {} as IDadosRelatorioInventarioPorLote,
      itens: [] as IDTORelatorioInventarioPorLote[],
      paginacao: {} as IPagination,
      paginacaoAPI: { totalRegistros: 0, paginaAtual: 1 } as IListaPaginadaMetaData,
      timerRegistros: 0,
      totalRegistrosComMascara: '100',
      arquivoPdf: [] as IArquivoPdf[],
      mostrarFiltros: ['1'],
      mostrarItens: false,
      cacheAutomatico: {} as ISalvamentoAutomatico,
    });
    telaBase.apresentarEmpresas = false;

    function preencherColunas() {
      if (storeSistema.state.layoutMobile) {
        gradeBase.colunas = [
          {
            title: 'Item', dataIndex: 'codigoInterno', key: 'Item', position: 1, visible: true,
          },
        ];
      } else {
        gradeBase.colunas = [
          {
            title: 'Tipo Produto', dataIndex: 'tipoProduto', key: 'tipoProduto', position: 1, visible: true, align: 'left', width: 200,
          },
          {
            title: 'NCM', dataIndex: 'ncm', key: 'ncm', position: 2, visible: true, align: 'left', width: 120,
          },
          {
            title: 'Cód. Produto', dataIndex: 'codigoInterno', key: 'codigoInterno', position: 3, visible: true, align: 'left', width: 125,
          },
          {
            title: 'Descrição', dataIndex: 'descricaoProduto', key: 'descricaoProduto', position: 4, visible: true, align: 'left',
          },
          {
            title: 'Lote', dataIndex: 'lote', key: 'lote', position: 5, visible: true, align: 'left', width: 175,
          },
          {
            title: 'Quantidade', dataIndex: 'quantidade', key: 'quantidade', position: 6, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'Unidade', dataIndex: 'unidade', key: 'unidade', position: 7, visible: true, align: 'center', width: 100,
          },
          {
            title: 'Custo Médio', dataIndex: 'custoMedio', key: 'custoMedio', position: 8, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'Valor Total', dataIndex: 'valorTotal', key: 'valorTotal', position: 9, visible: true, align: 'right', width: 150, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
        ];
      }
    }

    function obterIdentificadorCache(): string {
      return `RELATORIO_INVENTARIO_LOTE_${storeSistema.getters.codigoUsuarioAutenticado()}`;
    }

    function salvarCache() {
      const identificador = obterIdentificadorCache();
      state.cacheAutomatico.data = UtilitarioData.obterDataAtual();
      state.cacheAutomatico.codigoEmpresa = state.filtros.empresa;
      state.cacheAutomatico.codigoUsuario = storeSistema.getters.codigoUsuarioAutenticado();
      state.cacheAutomatico.identificador = telaBase.identificadorRecurso;
      state.cacheAutomatico.dados = JSON.stringify(state.filtros);
      servicoSistema.salvamentoAutomaticoLocalStorage(`${identificador}`, state.cacheAutomatico);
    }

    async function buscarRelatorio() {
      telaBase.carregando = true;
      state.filtros.numeroPagina = state.paginacao.current;
      state.filtros.qtdRegistrosPagina = state.paginacao.pageSize;
      state.filtros.qtdTotalRegistros = state.paginacao.total;
      state.filtros.empresa = storeSistema.getters.codigoEmpresaOperacao();
      state.resultado = await servicoRelatorioEstoque.obterInventarioPorLote(state.filtros);
      console.log('Dados do resultado:', state.resultado);
      state.filtrosUtilizados = UtilitarioGeral.clonarObjeto(state.filtros);
      salvarCache();
      preencherColunas();
      state.mostrarItens = true;
      if (state.resultado && state.resultado.itens) {
        state.itens = state.resultado.itens.dados;
        state.paginacaoAPI = state.resultado.itens.metaData;
      } else {
        state.itens = [];
      }
      state.mostrarFiltros = [];
      telaBase.carregando = false;
    }

    async function alterarQuantidadeRegistroTotal(valor: any) {
      clearTimeout(state.timerRegistros);
      let totalRegistros = 100;
      state.timerRegistros = setTimeout(async () => {
        if (UtilitarioGeral.valorValido(valor)) {
          const limiteRegistros = UtilitarioMascara.removerMascaraNumero(valor);
          if (limiteRegistros > 0) {
            totalRegistros = limiteRegistros;
          }
        }
        state.paginacao.total = totalRegistros;
        state.totalRegistrosComMascara = UtilitarioMascara.mascararNumeroInteiro(totalRegistros);
        await buscarRelatorio();
      }, 600);
    }

    async function imprimir(tipoArquivoRelatorio:ETipoArquivo) {
      telaBase.carregando = true;
      if (!UtilitarioGeral.validaLista(state.itens)) {
        await buscarRelatorio();
      }
      const retornoRelatorio = await servicoRelatorioEstoque.obterArquivoInventarioPorLote(tipoArquivoRelatorio, state.filtrosUtilizados);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivoPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.filtros.empresa);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      await buscarRelatorio();
    }

    function limparFiltros() {
      state.filtros = {} as IFiltroRelatorioInventarioPorLote;
      state.filtros.empresa = storeSistema.getters.codigoEmpresaOperacao();
      state.filtros.dataCorte = UtilitarioData.obterDataAtual();
      state.filtros.categorias = [];
      state.filtros.marcas = [];
      state.filtros.fornecedores = [];
      state.filtros.tipoCusto = 0;
    }

    async function onPageChange(current: number, pageSize: number) {
      state.paginacao.current = current;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    async function onShowSizeChange(current: number, pageSize: number) {
      state.paginacao.current = 1;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    watch(() => storeSistema.state.layoutMobile, () => {
      preencherColunas();
    });

    onBeforeMount(async () => {
      preencherDadosRota();
      await preencherEmpresasDisponiveis();
      await defineEmpresasSelecionadasComPermissao();
      verificaConceitoParaApresentarEmpresas();
      preencherColunas();
      limparFiltros();
      state.paginacao.total = 100;
      state.paginacao.showSizeChanger = true;
      state.paginacao.pageSize = 100;
      state.paginacao.current = 1;
      state.paginacao.pageSizeOptions = ['10', '50', '100', '500', '1000'];
    });

    return {
      state,
      props,
      window,
      ETipoArquivo,
      ECustomRenderRow,
      UtilitarioMascara,
      UtilitarioData,
      UtilitarioDispositivo,
      storeSistema,
      telaBase,
      gradeBase,
      limparFiltros,
      obterIdentificadorCache,
      salvarCache,
      buscarRelatorio,
      atualizarSelecaoEmpresas,
      imprimir,
      alterarQuantidadeRegistroTotal,
      onPageChange,
      onShowSizeChange,
    };
  },
});
